<template>
    <div>
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
          <b-row>
              <b-col cols="12">
                 <b-card>
                    <div slot="header" class="mb-0">
                        <!-- <h3 v-if="direction == 'IN'">{{language_terms['STOCK_IN']}}</h3>
                        <h3 v-if="direction == 'OUT'">{{language_terms['STOCK_OUT']}}</h3> -->
                        <h3>{{document_title}} - {{document_id}}</h3>
                    </div>
                    <b-row>
                        <b-col cols="12">
                            <b-row>
                                <b-col cols="6">
                                    <base-input :label="language_terms['WAREHOUSE']">
                                        <el-select v-model="stockadjustment.warehouse_id" filterable :placeholder="language_terms['WAREHOUSE']">
                                            <el-option
                                                v-for="option in warehouses"
                                                :key="option.id"
                                                :label="option.name"
                                                :value ="option.id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col cols="6">
                                    <base-input :label="language_terms['DATE']" >
                                        <flat-picker
                                            slot-scope="{ focus, blur }"
                                            @on-open="focus"
                                            @on-close="blur"
                                            style="background-color: white"
                                            class="form-control datepicker"
                                            v-model="stockadjustment.date">
                                        </flat-picker>
                                    </base-input>
                                </b-col>
                                <b-col cols="12" class="mt-2">
                                    <base-input :label="language_terms['REMARKS']">
                                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="stockadjustment.remarks"></textarea>
                                    </base-input>
                                </b-col>
                            </b-row>
                            <b-row v-if="$route.params.id == '_new'">
                                <b-col cols="12">
                                    <dropzone id="myVueDropzoneLC" 
                                        ref="myVueDropzoneLC" 
                                        class="mb-2" 
                                        :options="dropzoneOptions" 
                                        v-on:vdropzone-sending="uploadXLSX($event)" 
                                        >
                                        <!-- v-on:vdropzone-removed-file ="xxxx"  -->
                                        <input type="hidden" name="token" value="xxx">
                                    </dropzone>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="5">
                                    <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                                    <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="entry.product_code"/>
                                </b-col>
                                <b-col cols="2">
                                    <base-input v-model="entry.qty_onhand" type="number" disabled :label="language_terms['SYSTEM'] + ' ' + language_terms['QTY']" :min="0"></base-input>
                                </b-col>
                                <b-col cols="2">
                                    <base-input v-model="entry.qty_adjusted" type="number" :label="language_terms['ADJUSTED'] + ' ' + language_terms['QTY']"></base-input>
                                </b-col>
                                <b-col cols="2">
                                    <base-input v-model="entry.qty_new" :placeholder="entry.qty_new" type="number" :label="language_terms['NEW'] + ' ' + language_terms['QTY']" :min="0"></base-input>
                                </b-col>
                                <b-col cols="1" class="mt-4">
                                    <base-button icon type="success" @click="clickOnAdd" class="mt-2"
                                    :disabled="entry.product_code == null || (entry.qty_adjusted == '' && entry.qty_new == '') || (entry.qty_adjusted != '' && entry.qty_new != '')" >
                                        {{language_terms['ADD']}}
                                    </base-button>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4" v-if="stockadjustment.items.length > 0">
                                <b-col cols="12">
                                    <b-table-simple hover responsive>
                                        <b-thead head-variant="light">
                                            <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                            <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                            <b-th>{{language_terms['SYSTEM'] + ' ' + language_terms['QTY']}}</b-th>
                                            <b-th>{{language_terms['ADJUSTED'] + ' ' + language_terms['QTY']}}</b-th>
                                            <b-th>{{language_terms['NEW'] + ' ' + language_terms['QTY']}}</b-th>
                                            <b-th></b-th>
                                        </b-thead>
                                        <b-tbody v-for="(item, index) in stockadjustment.items" :key="index"  v-on:click="onClickList(index)">
                                            <tr>
                                                <td>{{item.product_code}}</td>
                                                <td>{{item.product_name}}</td>
                                                <td>{{item.qty_onhand}}</td>
                                                <td>{{item.qty_adjusted}}</td>
                                                <td>{{item.qty_new}}</td>
                                                <td>
                                                    <base-button  size="sm" icon type="danger" @click="deleteItem(index)" class="mr-4"><i class="fas fa-trash-alt"></i ></base-button>
                                                </td>
                                            </tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                 </b-card>
              </b-col>
          </b-row>
      </b-container>
      <div class="floating-bar">
        <div class="floating-bar-container" align="center">
            <b-button-group>
              <!-- <b-button class="transparent-btn" @click="editDocument"  v-if="(is_edit == 0) && (document_mode != 'approval') && purchase_document.is_locked != 1">
                <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
              </b-button>
              <b-button class="transparent-btn" @click="printDocument" v-if="(is_edit == 0)">
                <i class="fas fa-print mr-2 text-info"></i>{{language_terms['PRINT']}}
              </b-button> -->
              <b-button class="transparent-btn" @click="onClickSave" v-if="is_edit && $route.params.id == '_new'">
                <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}} 
              </b-button>
              <b-button class="transparent-btn" @click="onClickCancel" v-if="is_edit">
                <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CANCEL']}}
              </b-button>
            </b-button-group>
        </div>
      </div>      
    </div>
    
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import { mapState } from 'vuex';
import Vue from 'vue'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import productLookup from "@/components/Autocomplete.vue";
import locationLookup from "@/components/Autocomplete.vue";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
    components:{
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        productLookup,
        locationLookup,
        Dropzone,
    },
    data(){
        return{
            dropzoneOptions: 
            {
                maxFiles: 1,
                timeout: 1800000,
                url: "https://httpbin.org/post",
                thumbnailWidth: 200,
                addRemoveLinks: false,
                maxFilesize: 50,
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer '+ localStorage.access_token
                    }
            },
            document_title: 'Stock Adjustment',
            code_indicative:'',
            is_edit:true,
            stockadjustment:{
                date:null,
                warehouse_id:null,
                remarks:null,
                items:[],
            },
            loadCounter:0, 
            locations:[],
            is_confirmed:0,
            display_location:"1",
            sos:[],
            pos:[],
            entry:{
                qty_new:null,
                qty_onhand:null,
                qty_adjusted:null,
                remarks:"",
                product_code:null,
                product_id:null,
                product_name:"",
            },
            apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
        }
    },
      computed:{
        ...mapState({
            language_terms:(state)=>state.languages.language_terms,
            warehouses:(state)=>state.locations.warehouses,
            is_confirmation_required:(state) => state.stockcards.is_confirmation_required,
            confirmation_messages:(state) => state.stockcards.confirmation_messages,
        })
    },
    async mounted(){
        let document_id = this.$route.params.id;
        
        await this.$store.dispatch("locations/fetchWarehouses", {});

        if(this.warehouses.length > 0)
        {
            if(!this.stockadjustment.warehouse_id)
            {
                this.stockadjustment.warehouse_id = this.warehouses[0].id
            }
        }

        if(document_id == '_new')
        {
            this.document_title = "New Stock Adjustment";

            await this.getIndicativeCode()

            if(!this.stockadjustment.date)
            {
                this.stockadjustment.date = moment().format("YYYY-MM-DD");
            }
        }
        else
        {
            this.retrieveStockAdjustment(document_id)
        }
    },
    methods: 
    {
        async retrieveStockAdjustment(code)
        {
            this.loadCounter ++

            let apiUrl = apiRoutes['STOCKADJUSTMENT_RETRIEVE']
            let pv = { code: code };
            axios.post(apiUrl, pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                this.stockadjustment = response.data.data
            } 
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
                });
            } 
            else 
            {
                console.log("Problem Querying Data", error);
            }
            });
            

            this.loadCounter --
        },
        async uploadXLSX(file)
        {
            this.loadCounter++

            let formData = new FormData();
            var filename = file.name

            formData.append(filename, file);

            let vm = this
            let apiUrl = apiRoutes['STOCKADJUSTMENT_UPLOAD_XLSX']
            await axios.post(apiUrl, formData, authHeader()).then(res => 
            {
                    if (res.data.code == 1)
                    {
                        this.stockadjustment.items = res.data.data
                        vm.$refs.myVueDropzoneLC[0].removeFile(file)
                        location.reload()
                    }
                    else
                    {
                        alert(res.data.msg)
                        vm.$refs.myVueDropzoneLC[0].removeFile(file)
                    }
            })
            .catch(function()
            {
                // alert('Upload error');
            });
            
            this.loadCounter--
        },
        async getIndicativeCode()
        {
            let pv = {type: 'STOCKADJUSTMENT'};
            let code = null

            axios.post(apiRoutes["DOCUMENT_GET_CODE"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                code = response.data.msg
                this.code_indicative = code
                if (code != '')
                this.document_title += ' (' + code + ')';
                // this.purchase_document.code_indicative = response.data.msg
                // this.code_indicative = response.data.msg
            } 
            else 
            {
                this.stockadjustment.code_indicative = ''
            }
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
            } 
            });

            return code
        },      
        async onClickList(index)
        {
            // alert(this.stockadjustment.items[index].product_code)
            // alert(this.stockadjustment.items[index].product_id)
            this.entry.product_code = this.stockadjustment.items[index].product_code
        },
        async onClickSave() 
        {

          if (this.$route.params.id == "_new") 
          {
            this.loadCounter++

            let doc = this.stockadjustment
            let payload = {date: doc.date, remarks: doc.remarks, items: doc.items};
            axios.post(apiRoutes["STOCKADJUSTMENTS_SAVE"], payload, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                Vue.notify({group: "notify", type: "success", text: 'Stock Adjustment saved ' + response.data.data.code, max: 5, duration: 10000, speed: 300,});
                this.routeToMaster();
            } 
            else 
            {

            }
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            } 
            });

            this.loadCounter --
            
            // let code = this.code_indicative
            // this.purchase_document.type = this.type;
            // await this.$store.dispatch("purchase/create", this.purchase_document);

            // if(this.purchase_is_created)
            // {
            //   if (code != localStorage.document_code)
            //     alert('Document code is reassigned to\r\n\r\n' + localStorage.document_code)

            //   await this.searchPurchase();
            //   this.routeToMaster();
            // }
          } 
          else 
          {
            // this.purchase_document.type = this.type;
            // await this.$store.dispatch("documentRevisions/create", this.purchase_document);

            // if(this.revision_is_created == "1")
            // {
            //     await this.searchPurchase();
            //     this.routeToMaster();
            // }
            // await this.$store.dispatch("purchase/update", this.purchase_document);
            // if(this.purchase_is_updated == "1")
            // {
            //     await this.searchPurchase();
            //     this.routeToMaster();
            // }
          }
        },
        routeToMaster() 
        {
            this.$router.push("/inventory/stockadjustments");
        },
        onClickCancel() 
        {
            if(this.$route.params.id == '_new')
            {
              this.routeToMaster()
            }
            else
            {
              location.reload();
            }        
        },
        onChangeQtyNew(val)
        {
            this.entry.qty_adjusted = this.entry.qty_new - this.entry.qty_onhand 
        },
        addTag(newTag)
        {
            if(newTag)
            {
                let obj = {product_name: newTag, contact_id:this.entry.contact_id, date:this.entry.movement_date}
                if(this.isFoundInList(newTag) == 0)
                {
                    this.desp_tags.push(obj)
                    Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
                    this.entry.trade_item = obj
                    this.entry.product_name = newTag
                }

            }
        },
        onSelectTradeItemDesp(selectedOption)
        {
            if(selectedOption)
            {
                this.entry.product_name = selectedOption.product_name
            }
        },
        async asyncFindTradeItemDespForAdjustment (query) {
            let product_id = this.entry.product_id
            let pv = { value: query, contact_id:this.entry.contact_id, date:this.entry.movement_date, product_id: product_id, is_adjustment:1};
            axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                this.tradeitem_desp_list = response.data.data
            } 
            else 
            {
                this.tradeitem_desp_list = []
            }
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            } 
            });
        },
        async asyncFindTradeItemDesp (query) 
        {
            let product_id = this.entry.product_id
            let pv = { value: query, contact_id:this.entry.contact_id, date:this.entry.movement_date, product_id: product_id};
            axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                this.tradeitem_desp_list = response.data.data
                Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
            } 
            else 
            {
                this.tradeitem_desp_list = []
            }
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
                });
            } 
            else 
            {
                console.log("Problem Querying Data", error);
            }
            });
        },
        async onChangeAllocateQty(item, index)
        {

            if(item)
            {
                await this.$store.dispatch("sales/validateSoQtyForDo" , {document_item_id:item.id, allocate_qty:item.allocate_qty})
                item.allocate_qty = item.allocate_qty * 1
                if(item.allocate_qty > this.allow_qty)
                {
                    item.allocate_qty = this.allow_qty
                    this.$set(this.stockadjustment.items, index , item) 
                }
            }
            
        
        },
        onSelectLocationForItem(index, item)
        {
            let selectedOption = item.location
            if(selectedOption)
            {
                item.location_id = selectedOption.id
                item.location_code = selectedOption.code
                item.location_name = selectedOption.name
                this.$set(this.stockadjustment.items, index , item) 

            }
        },
        onSelectLocation(selectedOption)
        {
            if(selectedOption)
            {
                this.entry.location_id = selectedOption.id
                this.entry.location_code = selectedOption.code
                this.entry.location_name = selectedOption.name
                this.entry.available_qty = selectedOption.available_qty
            }
        },
        handleCollaspe(index, row)
        {
            if(row.is_collapsed)
            {
                row.is_collapsed = false
            }
            else
            {
                row.is_collapsed = true
            }

            this.$set(this.stockadjustment.items, index , row) 
        },
        async onSelectVendor(selectedOption)
        {
            if(selectedOption)
            {
                this.entry.contact_id = selectedOption.id

                if(this.entry.type == 'GRN_PO')
                {
                    await this.$store.dispatch("purchase/fetchPosForGRN" , {contact_id:selectedOption.id})

                    if(this.po_list)
                    {
                        this.pos = this.po_list
                    }
                }
            }
        },
        async onSelectCustomer(selectedOption)
        {
            if(selectedOption)
            {
                this.entry.contact_id = selectedOption.id

                if(this.entry.type == 'DO_SO')
                {
                    await this.$store.dispatch("sales/fetchSosForDo" , {contact_id:selectedOption.id})

                    if(this.so_list)
                    {
                        this.sos = this.so_list
                    }
                }
            }
        },
        getWHDetails(id)
        {   
            let data = {}
            for(let i = 0; i < this.warehouses.length; i++)
            {
                if(this.warehouses[i].id == id) {
                    data = this.warehouses[i]
                }
            }

            return data

        },

        deleteItem(index)
        {
            this.stockadjustment.items.splice(index, 1);
        },
        onComplete()
        {
            //this.createStockAdjustment()
        },
        getTotalLotQty(lots)
        {
            let sum = lots.reduce(function(sum, lot) {
                let updatedSum = sum + (lot.qty *1);
            return updatedSum;
            }, 0);


            return sum;
        },
        clickOnAdd()
        {
            // if(this.entry.allocate_qty == '' || this.entry.allocate_qty == null || this.entry.allocate_qty ==  0 || this.entry.location_id == '')
            if(this.entry.qty_new == '' && this.entry.qty_adjusted == '')
            {
                alert("Invalid Qty")
            }
            else if(this.entry.qty_new != '' && this.entry.qty_adjusted != '')
            {
                alert("Invalid Qty Entry")
            }
            else
            {
                this.addToList()
            }
        },
        isFoundInList(name)
        {
            let is_found = 0
            for(let i = 0; i < this.desp_tags.length; i++)
            {
                if(this.desp_tags[i].product_name == name)
                {
                is_found = 1
                }
            }
            return is_found;
        },
        addToList()
        {
            let err = ''

            if (this.entry.qty_adjusted != '')
            {
                if (parseInt(this.entry.qty_onhand) + parseInt(this.entry.qty_adjusted) >= 0 || 1)
                    this.entry.qty_new = parseInt(this.entry.qty_onhand) + parseInt(this.entry.qty_adjusted)
                else
                    err = 'Invalid Qty'
            }
            else if (this.entry.qty_new != '')
                this.entry.qty_adjusted = this.entry.qty_new - this.entry.qty_onhand

            if (err == '')
            {
                let entry = {
                "product_id":this.entry.product_id, 
                "product_code":this.entry.product_code, 
                "product_name":this.entry.product_name, 
                "qty_new":this.entry.qty_new, 
                "qty_onhand":this.entry.qty_onhand, 
                "qty_adjusted":this.entry.qty_adjusted, 
                }

                // Check if entry is already in list
                let x = null
                for(let i = 0; i < this.stockadjustment.items.length && x == null; i++)
                {
                    if(this.stockadjustment.items[i].product_id == entry.product_id)
                    { 
                        x = i
                    }
                }

                if (x != null)
                {
                    this.stockadjustment.items[x].qty_new = entry.qty_new
                    this.stockadjustment.items[x].qty_onhand = entry.qty_onhand
                    this.stockadjustment.items[x].qty_adjusted = entry.qty_adjusted                
                }
                else
                    this.stockadjustment.items.push(entry)

                this.entry.product_code = null;
                this.entry.product_id = null
                this.entry.product_name = null
                this.entry.qty_new = null
                this.entry.qty_onhand = null
                this.entry.qty_adjusted = null
            }
            else
                alert(err)
        },
        selectLocation(obj)
        {            
            if(obj)
            {
                this.entry.location_id = obj.id
                this.entry.location_code = obj.code
                this.entry.location_name = obj.name
            }
        },
        async selectProduct(obj)
        {
            // console.log(obj)
            if(obj)
            {
                if (isNaN(obj.qty_adjusted))
                    obj.qty_adjusted = 0

                this.entry.product_id = obj.id
                this.entry.product_code = obj.code
                this.entry.product_name = obj.name
                this.entry.qty_onhand = parseInt(obj.qty_onhand) + parseInt(obj.qty_adjusted)
                this.entry.qty_new = ''
                this.entry.qty_adjusted = ''
                
                //await this.asyncFindLocation()
            }
        },
        async createStockCard()
        {

        }
    }
}

</script>
